import Vue from 'vue'
import Router from 'vue-router'
import Listings from '@/components/Listings'
import ListingDetail from '@/components/ListingDetail'
import Register from '@/components/Register'
import Reservation from '@/components/Reservation'
import PasswordRecovery from '@/components/PasswordRecovery'
import RegistrationCompleted from '@/components/RegistrationCompleted'
import MyAccount from '@/components/MyAccount'
import Logout from '@/components/Logout'
import Checkout from '@/components/Checkout'
import PasswordChange from '@/components/PasswordChange'
import Login from '@/components/Login'
import Payment from '@/components/Payment'
import PageNotFound from '@/components/PageNotFound'
import Topup from '@/components/Topup'
import Version from '@/components/utilities/Version'
import WidgetMaker from '@/components/WidgetMaker'

import { store } from '../state/store'

Vue.use(Router)

let onlyAllowGuest = (to, from, next) => {
  console.info('Guest guard')
  if (store.getters.user.id) {
    next({name: 'Home', params: to.params})
  } else {
    next()
  }
}

let onlyAllowAuthenticated = (to, from, next) => {
  console.info('Authenticated guard')
  if (!store.getters.user.id) {
    next({name: 'Login', params: to.params})
  } else {
    next()
  }
}

let onlyWithTransaction = (to, from, next) => {
  if (!store.getters.reservation) {
    console.error('Reservation not found, redirected back')
    next({name: 'Listings', params: to.params})
  } else {
    next()
  }
}


const navigation = [
  {
    path: '',
    name: 'Home',
    redirect: { name: 'Listings' },
  },
  {
    path: 'register/:transaction?',
    name: 'Register',
    component: Register,
    props: (route) => ({ personal: route.query.p }),
    beforeEnter: onlyAllowGuest,
  },
  {
    path: 'login',
    name: 'Login',
    component: Login,
    beforeEnter: onlyAllowGuest,
  },
  {
    path: 'logout',
    name: 'Logout',
    component: Logout,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: 'topup',
    name: 'Topup',
    component: Topup,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: 'register/completed/:token/:userId',
    name: 'RegistrationCompleted',
    component: RegistrationCompleted,
    beforeEnter: onlyAllowGuest,
  },
  {
    path: 'reset_password',
    name: 'PasswordRecovery',
    component: PasswordRecovery,
    beforeEnter: onlyAllowGuest,
  },
  {
    path: 'change_password',
    name: 'PasswordChange',
    component: PasswordChange,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: 'listing/:campsite/reservation',
    name: 'Reservation',
    component: Reservation,
  },
  {
    path: 'booking/:campsite',
    name: 'Booking',
    props: {
      mode: 'ecpWidget'
    },
    component: Reservation,
  },
  {
    path: 'checkout',
    name: 'Checkout',
    component: Checkout,
    beforeEnter: onlyWithTransaction,
  },
  {
    path: 'booking/checkout',
    name: 'BookingCheckout',
    props: {
      mode: 'ecpWidget'
    },
    component: Checkout,
  },
  {
    path: 'recreation/checkout/:campsiteid',
    name: 'Recreation',
    props: {
      mode: 'recreation'
    },
    component: Checkout,
  },
  {
    path: 'payment/result/id/:transaction',
    name: 'Payment',
    component: Payment,
    // beforeEnter: onlyWithTransaction,
  },
  {
    path: 'products/result/:sessionid',
    name: 'RecreationPayment',
    component: Payment,
    props: {
      mode: 'recreation'
    },
  },
  {
    path: 'account',
    name: 'MyAccount',
    component: MyAccount,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: 'listings',
    name: 'Listings',
    component: Listings,
  },
  {
    path: 'listing/:id',
    name: 'Detail',
    component: ListingDetail,
  },
  {
    path: '/version',
    name: 'version',
    component: Version,
  },
  {
    path: 'WidgetMaker/:campsiteid',
    name: 'WidgetMaker',
    component: WidgetMaker,
  },
  {
    path: 'RecreationWidgetMaker/:campsiteid',
    name: 'RecreationWidgetMaker',
    component: WidgetMaker,
    props: {
      mode: 'recreation'
    },
  },
]

let redirectFunction = (to) => {
  // Redirect to lang + path
  return `/${store.getters.language || window.getBrowserLanguage()}${to.path}`
}

let availablePaths = navigation.map(nav => {
  return {
    path: `/${nav.path}`,
    name: `NoLang${nav.name}`,
    redirect: redirectFunction,
  }
})


export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/:lang(de|en|es|fr|nl)', // @FIXME: Hard coded language ids, but languages is not present in store yet!
      component: {
        template: '<router-view />',
      },
      children: navigation,
    },
    ...availablePaths,
    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound,
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js